<div class="pdf-header">
  <button
    nbButton
    ghost
    status="basic"
    size="small"
    (click)="navigateBack()"
    nbTooltip="Zurück"
    nbTooltipPlacement="bottom"
  >
    <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
    <span class="label">Zurück</span>
  </button>
</div>
<div *ngIf="id === '' || pdfLoadFailed">
  <p>Der Link funktioniert nicht. Hinweis: Er könnte abgelaufen sein.</p>
</div>
<div *ngIf="id !== '' && !pdfLoadFailed">
  <div *ngIf="pdfUrl" style="height: 90vh; width: 100%;">
    <iframe [src]="pdfUrl" width="100%" height="100%"></iframe>
  </div>
</div>
